define((require) => {
    "use strict";

    const _                   = require("underscore");
    const AbstractWidgetModel = require("shared/ui/experience/widgets/AbstractWidgetModel");
    const Backbone            = require("backbone");
    const WidgetCollection    = require("shared/ui/experience/widgets/WidgetCollection");

    /**
     * Model for a composite widget.
     *
     * @class CompositeWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("CompositeWidgetModel", {

        relations: (AbstractWidgetModel.prototype.relations || []).concat([{
            type: Backbone.Many,
            key: "group",
            collectionType: WidgetCollection
        }]),

        defaults: _.defaults({
            type: "composite"
        }, AbstractWidgetModel.prototype.defaults),

        _hasPositionOffset: false, // Keep track of bounding box translations state

        initialize() {
            this.listenTo(this, "change:scale", (model, value) => {
                this._scaleGroup(value);
            });

            this.__super();
        },

        /**
         * Define size and position of the composite model
         * and update the position of its group widgets
         * to compensate for the position offset
         *
         * @param {Object} setSizeAndPosition Size and position properties (left, top, width and height)
         * @param {Boolean} forceUpdate True to set size and position regardless of current state
         */
        setSizeAndPosition(sizeAndPosition, forceUpdate) {
            if (this._hasPositionOffset && !forceUpdate) {
                return;
            }

            this.set({
                left: sizeAndPosition.left + this.get("left"),
                top: sizeAndPosition.top + this.get("top"),
                width: sizeAndPosition.width,
                height: sizeAndPosition.height
            }, {
                cause: "group" // Don't trigger change to the activity manager (undo/redo)
            });

            // Translate group widgets to compensate for the position offset
            this._setGroupPositionOffset({
                left: sizeAndPosition.left,
                top: sizeAndPosition.top
            });

            this._hasPositionOffset = true;
        },

        _setGroupPositionOffset(positionOffset) {
            this.get("group").each((groupWidget) => {
                groupWidget.set({
                    top: groupWidget.get("top") - positionOffset.top,
                    left: groupWidget.get("left") - positionOffset.left
                }, {
                    cause: "group" // Don't trigger change to the activity manager (undo/redo)
                });
            });
        },

        /**
         * Reset the position offset done to each widget
         */
        resetGroupPositionOffset() {
            if (!this._hasPositionOffset) {
                return;
            }

            this.get("group").each((groupWidget) => {
                groupWidget.set({
                    top: groupWidget.get("top") + this.get("top"),
                    left: groupWidget.get("left") + this.get("left")
                }, {
                    cause: "group"
                });
            });

            this._hasPositionOffset = false;
        },

        _scaleGroup(scale) {
            this.get("group").invoke("set", "scale", scale);
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/compositeWidget/CompositeWidgetModel.js